<section class="mt-2">
  <i-title [text]="title"></i-title>
  <section class="mt-3">
    <div class="row">
      <div class="col-12">
        <p-fileUpload
          #pFileUpload
          name="myfileUpload[]"
          multiple="false"
          accept="image/*"
          fileLimit="1"
          [showUploadButton]="false"
          [showCancelButton]="false"
          [chooseLabel]="signatureBtn"
          styleClass="myUpload"
          [customUpload]="true"
          (onSelect)="onSelectFiles($event, pFileUpload)">
        </p-fileUpload>
      </div>
      <div class="col-12">
        @if (mySignature !== null) {
          <img [src]="mySignature" class="img-fluid d-block m-auto" width="400" />
        } @else {
          <div class="alert alert-primary">
            {{ noSignature }}
          </div>
        }
      </div>
    </div>
  </section>
</section>
